import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * A one-line status (loading, no access, an error) on its own white surface
 * (spec-64, U-086). Straight on the orange gradient such a line reached only
 * 1.5–2.7:1; here muted text is 5.6:1 and danger text 6.5:1.
 */
export function PageNote({
  children,
  tone = 'muted',
  role,
  className,
}: {
  children: ReactNode
  tone?: 'muted' | 'danger'
  role?: 'status' | 'alert'
  className?: string
}) {
  return (
    <p
      role={role}
      className={cn(
        'w-fit rounded-xl bg-card px-4 py-2 text-sm shadow-(--shadow-card)',
        tone === 'danger' ? 'text-danger' : 'text-muted-foreground',
        className,
      )}
    >
      {children}
    </p>
  )
}
